export enum DashboardActionTypes {
  GET_CURRENT_GROUP_SUMMARY = "GET_CURRENT_GROUP_SUMMARY",
  GET_CURRENT_STORE_SUMMARY = "GET_CURRENT_STORE_SUMMARY",
  POST_TO_SEARCH_GROUP_PEROID_SUMMARY = "POST_TO_SEARCH_GROUP_PEROID_SUMMARY",
  POST_TO_SEARCH_STORE_PEROID_SUMMARY = "POST_TO_SEARCH_STORE_PEROID_SUMMARY",
}

export type DashboardState = {
  group: {
    whole: TotalSummary;
    period: PeriodTotalSummary;
  };
  store: {
    whole: TotalSummary;
    period: StorePeriodSummary;
    // report: []
  };
};

export type TotalSummary = {
  avgCheckoutPrice: number;
  totalCheckoutPrice: number;
  totalDepositPoint: number;
  totalMemberCount: number;
  totalOrderCount: number;
  updatedAt: string;
};

export type PeriodTotalSummary = {
  totalCheckoutPrice: number;
  totalMemberCount: number;
  totalOrderCount: number;
};

export type ResourceProps = {
  id: number;
  name: string;
};

export interface ResourceSummary
  extends Pick<PeriodTotalSummary, "totalCheckoutPrice" | "totalOrderCount"> {
  totalDiscountPrice: number;
  resource: ResourceProps;
}

export interface StorePeriodSummary
  extends Pick<
    TotalSummary,
    "avgCheckoutPrice" | "totalCheckoutPrice" | "totalOrderCount"
  > {
  resources: ResourceSummary[];
  totalCheckoutPriceByDepositPoint: 0;
}

interface GetCurrentGroupSummaryInterface {
  type: typeof DashboardActionTypes.GET_CURRENT_GROUP_SUMMARY;
  payload: TotalSummary;
}

interface GetCurrentStoreSummaryInterface {
  type: typeof DashboardActionTypes.GET_CURRENT_STORE_SUMMARY;
  payload: TotalSummary;
}

interface PostToSearchGroupPeriodSummaryInterface {
  type: typeof DashboardActionTypes.POST_TO_SEARCH_GROUP_PEROID_SUMMARY;
  payload: PeriodTotalSummary;
}

interface PostToSearchStorePeriodSummaryInterface {
  type: typeof DashboardActionTypes.POST_TO_SEARCH_STORE_PEROID_SUMMARY;
  payload: StorePeriodSummary;
}

export type DashboardActions =
  | GetCurrentGroupSummaryInterface
  | GetCurrentStoreSummaryInterface
  | PostToSearchGroupPeriodSummaryInterface
  | PostToSearchStorePeriodSummaryInterface;
